import { Layout, Typography, Card, Row, Col, Image, Divider } from 'antd';
import { TeamOutlined, BulbOutlined, TrophyOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;
const { Content } = Layout;

const AboutUsPage = () => {
  const teamMembers = [
    { name: 'Alex Johnson', role: 'Founder & CEO', avatar: 'https://randomuser.me/api/portraits/men/32.jpg' },
    { name: 'Sarah Williams', role: 'Product Lead', avatar: 'https://randomuser.me/api/portraits/women/44.jpg' },
    { name: 'Michael Chen', role: 'Tech Director', avatar: 'https://randomuser.me/api/portraits/men/67.jpg' }
  ];

  return (
    <Layout className="about-page" style={{ background: '#fff' }}>
      <Content style={{ padding: '0 50px' }}>
        {/* Hero Section */}
        <section style={{ textAlign: 'center', padding: '60px 0' }}>
          <Title level={1} style={{ fontSize: '48px', marginBottom: 16 }}>Revolutionizing Retail</Title>
          <Paragraph style={{ fontSize: '18px', maxWidth: '800px', margin: '0 auto' }}>
            SellSmart empowers retailers with cutting-edge inventory and sales tracking solutions since 2018.
          </Paragraph>
        </section>

        {/* Our Story */}
        <section style={{ padding: '40px 0' }}>
          <Row gutter={[32, 32]} align="middle">
            <Col xs={24} md={12}>
              <Title level={2}>Our Story</Title>
              <Paragraph style={{ fontSize: '16px' }}>
                Founded in a small retail shop, we experienced firsthand the challenges of inventory management.
                What started as a simple spreadsheet solution has grown into a comprehensive platform serving
                over 5,000 retailers worldwide.
              </Paragraph>
              <Divider />
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <div style={{ textAlign: 'center' }}>
                    <TrophyOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
                    <Title level={4} style={{ margin: '8px 0' }}>5K+</Title>
                    <Text type="secondary">Happy Clients</Text>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ textAlign: 'center' }}>
                    <BulbOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
                    <Title level={4} style={{ margin: '8px 0' }}>15</Title>
                    <Text type="secondary">Countries</Text>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ textAlign: 'center' }}>
                    <TeamOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
                    <Title level={4} style={{ margin: '8px 0' }}>40+</Title>
                    <Text type="secondary">Team Members</Text>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs={24} md={12}>
              <Image
                src="https://images.unsplash.com/photo-1556740738-b6a63e27c4df?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
                alt="Retail team working"
                preview={false}
                style={{ borderRadius: '8px' }}
              />
            </Col>
          </Row>
        </section>

        {/* Our Team */}
        <section style={{ padding: '60px 0', textAlign: 'center' }}>
          <Title level={2} style={{ marginBottom: '48px' }}>Meet Our Team</Title>
          <Row gutter={[32, 32]} justify="center">
            {teamMembers.map((member, index) => (
              <Col key={index} xs={24} sm={12} md={8}>
                <Card
                  hoverable
                  cover={<img alt={member.name} src={member.avatar} style={{ height: '200px', objectFit: 'cover' }} />}
                  style={{ borderRadius: '8px' }}
                >
                  <Card.Meta
                    title={member.name}
                    description={member.role}
                    style={{ textAlign: 'center' }}
                  />
                </Card>
              </Col>
            ))}
          </Row>
        </section>
      </Content>
    </Layout>
  );
};

export default AboutUsPage;